// De pagina vers laden. Op de Pi blijft Chromium soms stroef lopen: de eerste pagina na het
// opstarten, en na een nacht zonder tv (ook zonder geluid). Een nieuw tabblad loopt dan wel
// soepel, en herladen doet hetzelfde zonder dat er iemand bij hoeft.
//   - na een nacht: hooks/useWakeReload.js
//   - bij haperend beeld: reloadForLag, vanuit de meting in renderTier.js

import { audioBusy } from "../audio/audioEngine";

const reasonKey = "tdReloadReason";
const lagKey = "tdLagReloadAt";

// Hooguit eens per zoveel tijd herladen om haperend beeld; hapert het daarna nog, dan is het
// deze Pi zelf en zakt de kwaliteitstrap zoals vroeger.
const lagRetryMs = 6 * 3600000;
// Nooit midden in een animatie herladen: wachten tot het stil is, maar niet eindeloos.
const idleCheckMs = 2000;
const idleMaxMs = 300000;

let animating = false;

// Vanuit useAnimations: loopt er nu iets in beeld?
export function markAnimating(busy) {
  animating = Boolean(busy);
}

// sessionStorage hoort bij dit tabblad en blijft staan als het herlaadt.
function read(key) {
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key, value) {
  try {
    window.sessionStorage.setItem(key, value);
  } catch {
    // Geen opslag: dan mag het herladen vaker, en komt er geen ping na.
  }
}

// Waarom dit laden gebeurde ("wake", "lag"), of null bij een gewoon laden; meteen vergeten.
export function takeReloadReason() {
  const reason = read(reasonKey);
  try {
    window.sessionStorage.removeItem(reasonKey);
  } catch {
    // Niets te vergeten.
  }
  return reason || null;
}

// Alleen herladen als de server antwoordt: anders blijft de tv op een foutpagina hangen.
async function serverAnswers() {
  if (window.navigator?.onLine === false) return false;
  try {
    const response = await fetch(window.location.href, { method: "HEAD", cache: "no-store" });
    return response.ok;
  } catch {
    return false;
  }
}

// Geeft false als de server niet antwoordde; anders herlaadt de pagina.
export async function reloadPage(reason, note = "") {
  if (!(await serverAnswers())) return false;
  console.info(`[dashboard] pagina wordt vers geladen${note ? ` (${note})` : ""}`);
  write(reasonKey, reason);
  window.location.reload();
  return true;
}

// Loopt het beeld stroef? Dan eerst vers laden zodra het stil is, en pas als het daarna nog
// hapert een trap lager. Geeft true als er herladen gaat worden.
export function reloadForLag() {
  if (typeof window === "undefined") return false;
  // Alleen het dashboard zelf; het animatielab verliest anders wat je aan het bekijken bent.
  if (!window.location.pathname.includes("/dashboard")) return false;
  const last = Number(read(lagKey)) || 0;
  if (Date.now() - last < lagRetryMs) return false;

  write(lagKey, String(Date.now()));
  const started = Date.now();

  const attempt = () => {
    const quiet = !animating && !audioBusy();
    if (!quiet && Date.now() - started < idleMaxMs) {
      setTimeout(attempt, idleCheckMs);
      return;
    }
    reloadPage("lag", "beeld liep stroef");
  };

  setTimeout(attempt, idleCheckMs);
  return true;
}
